import * as React from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const EmployeeArrowRight = (props: SvgIconProps) => {
  return (
    <SvgIcon width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fill="currentColor"
        d="M11.146 16.854a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L14.293 12H8a2 2 0 0 1-2-2V3.5a.5.5 0 0 0-1 0V10a3 3 0 0 0 3 3h6.293l-3.147 3.146a.5.5 0 0 0 0 .708Z"
      />
    </SvgIcon>
  );
};
